export default {
  // Footer
  'navigation:common:footer:about-us': 'About Us',
  'navigation:common:footer:faq': 'FAQ',
  'navigation:common:footer:brand-ambassador': 'Become a Brand Ambassador',
  'navigation:common:footer:bonus-program': 'Bonus Program',
  'navigation:common:footer:jobs': 'Jobs / Careers',

  // Trustbar
  'navigation:common:trustbar:consultation': 'Consultation',
  'navigation:common:trustbar:magazine': 'Magazine',
  'navigation:common:trustbar:faq': 'FAQ',
  'navigation:common:trustbar:bonus-program': 'Bonus Program',

  // Navigation Menu Items
  'navigation:menu:home': 'Home',
  'navigation:menu:dogs:home': 'Dogs',
  'navigation:menu:cats:home': 'Cats',

  // Dogs Common Needs
  'navigation:dogs:needs:title': 'By Need',
  'navigation:dogs:needs:picky-eaters': 'Picky Eaters',
  'navigation:dogs:needs:digestive-problems': 'Digestive Problems',
  'navigation:dogs:needs:skin-fur-problems': 'Skin & Coat Problems',
  'navigation:dogs:needs:intolerances': 'Intolerances',
  'navigation:dogs:needs:overweight': 'Overweight',

  // Dogs Age Categories
  'navigation:dogs:age:title': 'By Age',
  'navigation:dogs:age:puppy': 'Puppy (0-1 year)',
  'navigation:dogs:age:adult': 'Adult (1-8 years)',
  'navigation:dogs:age:senior': 'Senior (8+ years)',

  // Dogs Breeds
  'navigation:dogs:breeds:title': 'By Breed',
  'navigation:dogs:breeds:bulldog': 'Bulldog',
  'navigation:dogs:breeds:chihuahua': 'Chihuahua',
  'navigation:dogs:breeds:dachshund': 'Dachshund',
  'navigation:dogs:breeds:havanese-maltese': 'Havanese & Maltese',
  'navigation:dogs:breeds:poodle': 'Poodle & Poodle Mix',
  'navigation:dogs:breeds:retriever': 'Retriever',
  'navigation:dogs:breeds:shepherd': 'Shepherd Dog',
  'navigation:dogs:breeds:spitz': 'Spitz',
  'navigation:dogs:breeds:terrier': 'Terrier',
  'navigation:dogs:breeds:herding': 'Herding Dog',

  // Dogs Food Types
  'navigation:dogs:food:wet': 'Wet Food',
  'navigation:dogs:food:dry': 'Dry Food',

  // Dogs Product Types
  'navigation:dogs:products:sample-packs': 'Trial Packs',
  'navigation:dogs:products:wet-food': 'Wet Food',
  'navigation:dogs:products:dry-food': 'Dry Food',
  'navigation:dogs:products:barf': 'BARF',
  'navigation:dogs:products:snacks': 'Snacks',
  'navigation:dogs:products:accessories': 'Accessories',

  // Dogs Snacks
  'navigation:dogs:snacks:title': 'Snacks',
  'navigation:dogs:snacks:all': 'All Snacks',
  'navigation:dogs:snacks:surprise-box': 'Surprise Box',
  'navigation:dogs:snacks:dental-care': 'Dental Care',
  'navigation:dogs:snacks:functional': 'Functional Snacks',
  'navigation:dogs:snacks:bones': 'Bones & Chew Rolls',
  'navigation:dogs:snacks:strips': 'Chew Strips & Sticks',
  'navigation:dogs:snacks:training': 'Training Snacks',
  'navigation:dogs:snacks:pastes': 'Pastes & Cream Snacks',
  'navigation:dogs:snacks:toppers': 'Toppers',

  // Dogs Accessories and Health
  'navigation:dogs:accessories:title': 'Accessories',
  'navigation:dogs:health:title': 'Care & Health',
  'navigation:dogs:health:general': 'Health',
  'navigation:dogs:products:health': 'Health',

  // Dogs Additional Categories
  'navigation:dogs:categories:care': 'Care',
  'navigation:dogs:categories:supplements': 'Supplements',

  // Cats Navigation
  'navigation:cats:products:wet-food': 'Wet Food',
  'navigation:cats:products:dry-food': 'Dry Food',
  'navigation:cats:products:snacks': 'Snacks',
  'navigation:cats:products:sample-packs': 'Trial Packs',
  'navigation:cats:products:accessories': 'Accessories',
  'navigation:cats:products:health': 'Health',
  'navigation:cats:products:care': 'Care',
  'navigation:cats:products:supplements': 'Supplements',

  // Cats Needs
  'navigation:cats:needs:title': 'Special Needs',
  'navigation:cats:needs:picky-eaters': 'Very Picky',
  'navigation:cats:needs:digestive-problems': 'Digestive Problems',
  'navigation:cats:needs:outdoor': 'Outdoor Cat',
  'navigation:cats:needs:overweight': 'Overweight',
  'navigation:cats:needs:sterilized': 'Sterilized',

  // Cats Age
  'navigation:cats:age:title': 'By Age',
  'navigation:cats:age:kitten': 'Kitten (0-1 year)',
  'navigation:cats:age:adult': 'Adult (1-10 years)',
  'navigation:cats:age:senior': 'Senior (10+ years)',

  // Cats Snacks
  'navigation:cats:snacks:title': 'Snacks',
  'navigation:cats:snacks:all': 'All Snacks',
  'navigation:cats:snacks:surprise-box': 'Surprise Box',
  'navigation:cats:snacks:cream': 'Cream Snacks',
  'navigation:cats:snacks:soft': 'Soft Snacks',
  'navigation:cats:snacks:fillet': 'Filet Snacks',
  'navigation:cats:snacks:soups': 'Soups',
  'navigation:cats:snacks:sensitive': 'Sensitive',
  'navigation:cats:snacks:pastes': 'Pastes',

  // Common Service
  'navigation:common:service:title': 'Service',
  'navigation:common:service:dr-sam': 'Dr. Sam',
  'navigation:common:service:doguniversity': 'Doguniversity',
  'navigation:common:service:lassie': 'Lassie',

  // Footer - Useful Information
  'navigation:footer:useful:about-us': 'About Us',
  'navigation:footer:useful:healthy-pet-food': 'What is healthy pet food?',
  'navigation:footer:useful:premium-food': 'Why Premium Pet Food?',
  'navigation:footer:useful:food-transition': 'Food Transition',
  'navigation:footer:useful:our-stores': 'Our Stores',

  // Footer - Good For You
  'navigation:footer:good:refer-friends': 'Refer Friends',
  'navigation:footer:good:become-ambassador': 'Become a Brand Ambassador',
  'navigation:footer:good:savings-subscription': 'Our Savings Subscription',

  // Footer - Help
  'navigation:footer:help:faq': 'Frequently Asked Questions',
  'navigation:footer:help:shipping': 'Shipping',
  'navigation:footer:help:retail': 'Pets Deli in Retail',
  'navigation:footer:help:breeder-program': 'Breeder Program',

  // Footer - Legal
  'navigation:footer:legal:jobs': 'Jobs',
  'navigation:footer:legal:imprint': 'Imprint',
  'navigation:footer:legal:privacy': 'Privacy Policy',
  'navigation:footer:legal:terms': 'Terms & Conditions and Cancellation Policy',

  // Common
  'navigation:common:offers': 'Offers',

  // Header - Mobile
  'navigation:mobile:aria-label': 'Open or close navigation',
};
